<template>
    <div class="d-flex align-center customername" v-if="customer">
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <div v-on="isConnected ? on : null">
                    <span v-if="!link">{{ customer.name }}</span>
                    <lookup v-else-if="lookup" object="customer" :params="lookup" class="link">
                        {{ customer.name }}
                    </lookup>
                    <ScopedRouteLink
                        v-else-if="canLinkToCustomer"
                        link-class="link"
                        :to="{
                            name: 'customer',
                            params: {
                                customer_id: customer.id,
                            },
                        }"
                    >
                        <Stroke :strike="customer.archived">
                            {{ customer.name }}
                        </Stroke>
                    </ScopedRouteLink>
                    <span v-else>{{ customer.name }}</span>

                    <v-icon
                        v-if="isConnected"
                        :color="link ? 'primary' : null"
                        size="20"
                        class="ml-1 icon"
                        >mdi-link</v-icon
                    >
                </div>
            </template>
            <template v-if="isConnected">
                {{ $translate("customerIsConnected") }}
            </template>
        </v-tooltip>
    </div>
</template>

<script>
import GlobalMixins from "@/mixins/global";
import { canAccessNavigationRoute } from "@/utils/navigationPermissions";

export default {
    mixins: [GlobalMixins],
    props: {
        customer: {
            required: false,
            type: Object,
        },
        lookup: {
            required: false,
            type: Object,
        },
        link: {
            required: false,
            type: Boolean,
            default: true,
        },
        connected: {
            required: false,
            type: Boolean,
            default: null,
        },
    },
    i18n: {
        messages: {
            en: {
                customerIsConnected: "This customer is connected",
            },
            fr: {
                customerIsConnected: "Ce client est connecté",
            },
        },
    },
    computed: {
        isConnected() {
            return this.connected === true || this.customer.entity;
        },
        canLinkToCustomer() {
            return canAccessNavigationRoute("customer");
        },
    },
};
</script>

<style scoped>
.customername:hover .icon {
    opacity: 1;
}
</style>
